module.exports = __webpack_public_path__ + "static/img/sibarbg.442678d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sibarbg.png
// module id = ttA9
// module chunks = 1